import blocks from 'src/js/modules/blocks';
import hasBackgroundContainer from './has-background-container';
import isImageContainer from './is-image-container';
import { getSettings } from '../settings';

const getContentPositionInPercents = (node, overrides) => {
  const settings = getSettings();

  if (blocks.verifiers.isWsBlock(node) || hasBackgroundContainer(node)) {
    const backgroundContainer = node.querySelector(settings.backgroundContainer);
    return backgroundContainer.getContentPositionInPercents(overrides);
  }

  if (isImageContainer(node)) {
    return node.getContentPositionInPercents(overrides);
  }

  return null;
};

export default getContentPositionInPercents;
